import React, { useState, useEffect, useContext, useRef } from "react";
import "./Faq_Banner.css";
import { Accordion } from "react-bootstrap";
import { Faqs, FaqsCategory } from "../../../utils/apis/faq/Faq";
import ScrollToTop from "../../scrolltotop/ScrollToTop";

const Faq_Banner = () => {
  // const [activeTab, setActiveTab] = useState("Consumer Registration");


  const contentRef = useRef(null);
  const [faq, setFaq] = useState([]);
  const [activeTab, setActiveTab] = useState("");

  const getFaq = async () => {
    const res = await Faqs();
    console.log(res,"res res res")
    if (res?.success) {
      const data = res?.data|| [];
      setFaq(data);


    }
  };

  const [categories, setCategories] = useState([]);

  const getCategories = async () => {
    const res = await FaqsCategory();

    // console.log(res?.data, "response for categories")

    if (res?.success) {
      setCategories(res?.data); // stores all categories from API
    }
  };

  useEffect(() => {
    getFaq();
    getCategories();
  }, []);




  useEffect(() => {
    if (categories.length > 0) {
      setActiveTab(categories[0].id);
    }
  }, [categories]);

 const filteredFaq = faq?.filter(
  (item) => Number(item.faq_category_id) === Number(activeTab)
);



  return (
    <>
      <section className="Faq_Banner">
        <div className="container">
          {/* Banner */}
          <div className="Faq_Banner_holder">
            <img
              src="/assets/images/faq/faq-banner.png"
              className="Faq_img"
              alt="FAQ Banner"
            />
          </div>

          <div className="faq_wrapper">
            {/* LEFT SIDEBAR */}
            <div className="faq_sidebar">
              <h4 className="faq_title">Your questions, Answered simply.</h4>

              <div className="cats_holder">
                {categories?.map((category, index) => (
                  <div
                    key={index}
                    className={`faq_tab ${activeTab === category?.id ? "active" : ""
                      }`}
                    onClick={() => {
                      setActiveTab(category?.id);

                      window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                      });

                      // contentRef.current?.scrollIntoView({
                      //   behavior: "smooth",
                      //   block: "start",
                      // });
                    }}
                  >
                    {category?.name}
                  </div>
                ))}
              </div>
            </div>

            {/* RIGHT ACCORDION */}
            <div className="faq_content" ref={contentRef}>
              <Accordion defaultActiveKey="0" key={activeTab}>

                {filteredFaq?.length > 0 ? (
                  filteredFaq.map((item, index) => (
                    <Accordion.Item eventKey={index.toString()} key={item.id}>
                      <Accordion.Header>
                        {index + 1} {item?.question}
                      </Accordion.Header>

                      <Accordion.Body>{item?.answer}</Accordion.Body>
                    </Accordion.Item>
                  ))
                ) : (
                  <p className="no_faq_msg">No FAQs available for this category.</p>
                )}
              </Accordion>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Faq_Banner;
